import { FormGroup, FormBuilder, Validators, } from '@angular/forms';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalController, ToastController } from '@ionic/angular';
import { finalize } from "rxjs/operators";
import { SpinnerService } from '@/service/spinner.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { UserService } from '@/service/user.service';
import { User } from '@/dto/user/user';
import { TranslateService } from '@ngx-translate/core';
import { NetworkService } from '@/service/network.service';
import { ClientService } from '@/service/client.service';
import { KycService } from '@/service/kyc.service';

@Component({
    selector: 'app-useredit',
    templateUrl: './useredit.page.html',
    styleUrls: ['./useredit.page.scss']
})

export class UserEditPage implements OnInit, OnDestroy {
    navigationSubscription
    public dataForm: FormGroup;
    public pageIndex = 1;
    public pageSize: number;
    public total: number;
    public pageSizeOpts: number[];
    private unsubscribe: Subscription[] = [];
    private submitted = false;
    public isError = true
    private iduser: string;
    public listNetwork: any[] = [];
    public listClient: any[] = [];
    public listKyc: any[] = [];

    public listRole = [
        {
            id: 1, text: 'ADMIN'
        },
        {
            id: 2, text: 'CLIENT'
        },
        {
            id: 3, text: 'KYC'
        },
        {
            id: 4, text: 'NETWORK'
        },
        {
            id: 5, text: 'AdminBPS'
        }
    ]


    public listAccess = [{
        id: 0, text: '---'
    },
    {
        id: 1, text: 'API'
    },
    {
        id: 2, text: 'DASHBOARD'
    }
    ]

    @ViewChild('selectOption') selectOption: any;
    @ViewChild('selectOptionAccess') selectOptionAccess: any;

    constructor(private formBuilder: FormBuilder, public modalController: ModalController, public userService: UserService, private spinnerService: SpinnerService,
        public router: Router, private route: ActivatedRoute, public toastController: ToastController, private translateService: TranslateService,
        private networkService: NetworkService, private clientService: ClientService, private kycService: KycService) {

    }

    initialiseInvites() {
        this.iduser = this.route.snapshot.queryParams['iduser'];
        if (this.iduser) {
            this.dataForm = this.formBuilder.group({
                username: ['', [Validators.required]],
                firstname: ['', [Validators.required]],
                lastname: ['', [Validators.required]],
                email: ['', [Validators.email]],
                is_superuser: [false, []],
                is_staff: [false, []],
                is_active: [false, []],
                role_id: ['', []],
                access_id: ['', []],
                password: ['', []],
                confirmPassword: ['', []]
            }, {
                validator: MustMatch('password', 'confirmPassword')
            });
        } else {
            this.dataForm = this.formBuilder.group({
                username: ['', [Validators.required]],
                firstname: ['', [Validators.required]],
                lastname: ['', [Validators.required]],
                email: ['', [Validators.email]],
                is_superuser: [false, []],
                is_staff: [false, []],
                is_active: [false, []],
                role_id: ['', []],
                access_id: ['', []],
                password: ['', [Validators.required]],
                confirmPassword: ['', Validators.required]
            }, {
                validator: MustMatch('password', 'confirmPassword')
            });
        }
        this.unsubscribe.push(this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd && (event.url.includes('admin/edituser') || event.url.includes('admin/newuser'))) {
                this.initialize();
            }
        }));
    }

    initialize() {

        this.translateService.stream('Menu.text.Dashboard').subscribe(val => {
            this.listAccess = [{
                id: 0, text: '---'
            },
            {
                id: 1, text: 'Api'
            },
            {
                id: 2, text: val
            }
            ]
        })

        this.iduser = this.route.snapshot.queryParams['iduser'];

        if (this.iduser) {
            this.unsubscribe.push(this.userService.getById(this.iduser).pipe(finalize(() => {
                this.spinnerService.hide();
            }))
                .subscribe(
                    data => {
                        if (data) {
                            this.dataForm.patchValue({//data here to patch
                                username: data.username,
                                firstname: data.first_name,
                                lastname: data.last_name,
                                email: data.email,
                                is_superuser: data.is_superuser,
                                is_staff: data.is_staff,
                                is_active: data.is_active,
                                role_id: data.role_id,
                                access_id: data.access_id
                            });
                            if (data.role_id > 0)
                                this.loadRole(data);
                            if (data.access_id > 0)
                                this.loadAccess(data);
                            this.unsubscribe.push(this.clientService.get().subscribe(val => {
                                this.listClient = val;
                                for (let i = 0; i < this.listClient.length; i++) {
                                    if (data.clients.filter(c => c.id === this.listClient[i].id).length === 1)
                                        this.listClient[i]["Checked"] = true;
                                    else
                                        this.listClient[i]["Checked"] = false;
                                }
                            }))


                            this.unsubscribe.push(this.networkService.get().pipe(finalize(() => {
                            })).subscribe(val => {
                                this.listNetwork = val;
                                for (let i = 0; i < this.listNetwork.length; i++) {
                                    if (data.networks.filter(c => c.id === this.listNetwork[i].id).length === 1)
                                        this.listNetwork[i]["Checked"] = true;
                                    else
                                        this.listNetwork[i]["Checked"] = false;
                                }
                            }));

                            this.unsubscribe.push(this.kycService.get().pipe(finalize(() => {
                            })).subscribe(val => {
                                this.listKyc = val;
                                for (let i = 0; i < this.listKyc.length; i++) {
                                    if (data.kycs.filter(c => c.id === this.listKyc[i].id).length === 1)
                                        this.listKyc[i]["Checked"] = true;
                                    else
                                        this.listKyc[i]["Checked"] = false;
                                }
                            }));

                        }
                    }));
        }
        else {
            this.unsubscribe.push(this.networkService.get().pipe(finalize(() => {
            })).subscribe(val => {
                this.listNetwork = val;
                for (let i = 0; i < this.listNetwork.length; i++) {
                    this.listNetwork[i]["Checked"] = false;
                }
            }));
            this.unsubscribe.push(this.clientService.get().subscribe(val => {
                this.listClient = val;
                for (let i = 0; i < this.listClient.length; i++) {
                    this.listClient[i]["Checked"] = false;
                }
            }));
            this.unsubscribe.push(this.kycService.get().pipe(finalize(() => {
            })).subscribe(val => {
                this.listKyc = val;
                for (let i = 0; i < this.listKyc.length; i++) {
                    this.listKyc[i]["Checked"] = false;
                }
            }));

        }
    }

    ngOnInit() {
        this.initialiseInvites()
    }

    ngOnDestroy() {
        this.unsubscribe.forEach(s => s.unsubscribe());
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

    cancel() {
        this.router.navigate(['/admin/user']);
    }



    onSubmit() {

        this.dataForm.markAllAsTouched();
        if (this.dataForm.invalid || this.submitted) {
            return;
        }
        this.submitted = true;
        const dataUser = new User();
        dataUser.id = this.iduser !== undefined ? this.iduser : "";
        dataUser.username = this.f.username.value;
        dataUser.first_name = this.f.firstname.value;
        dataUser.last_name = this.f.lastname.value;
        dataUser.email = this.f.email.value;
        dataUser.is_superuser = this.f.is_superuser.value;
        dataUser.is_staff = this.f.is_staff.value;
        dataUser.is_active = this.f.is_active.value;
        dataUser.networks = this.listNetwork.filter(c => c.Checked);
        dataUser.kycs = this.listKyc.filter(c => c.Checked);
        dataUser.clients = this.listClient.filter(c => c.Checked);
        dataUser.role_id = this.parseValueFromUserInputRole(this.f.role_id.value);
        dataUser.access_id = this.parseValueFromUserInputAccess(this.f.access_id.value);
        dataUser.password = this.f.password.value;
        this.spinnerService.show();


        this.unsubscribe.push(this.userService.modify(dataUser).pipe(finalize(() => {
            this.spinnerService.hide();
            this.submitted = false;
        }))
            .subscribe(
                async data => {
                    if (data["response"] === "OK") {
                        let message = this.translateService.instant("User.Text.Saved");
                        const toast = await this.toastController.create({
                            message: message,
                            duration: 2000
                        });
                        toast.present()
                        this.router.navigate(['/admin/user']);

                        this.submitted = false;
                    }
                }));


    }

    loadRole(data) {
        let text = this.listRole.find(c => c.id === data.role_id).text;
        this.selectOption.nativeElement.setAttribute('placeholder', text);
        this.dataForm.patchValue({ role_id: text })
    }

    loadAccess(data) {
        let text = this.listAccess.find(c => c.id === data.access_id).text;
        this.selectOptionAccess.nativeElement.setAttribute('placeholder', text);
        this.dataForm.patchValue({ access_id: text })
    }

    handleChangeRole(e) {
        let txt_placeholder = e.target.value || ''
        this.selectOption.nativeElement.value = ''
        this.dataForm.patchValue({
            role_id: txt_placeholder
        })
        this.selectOption.nativeElement.setAttribute('placeholder', txt_placeholder)
    }

    handleChangeAccess(e) {
        let txt_placeholder = e.target.value || ''
        this.selectOptionAccess.nativeElement.value = ''
        this.dataForm.patchValue({
            access_id: txt_placeholder
        })
        this.selectOptionAccess.nativeElement.setAttribute('placeholder', txt_placeholder)
    }

    handleChangeNetwork(e, item) {
        setTimeout(() => {
            this.listNetwork.find(c => c.id === item.id).Checked = e.target.ariaChecked === 'true' ? true : false;
        }, 100)
    }

    handleChangeKyc(e, item) {
        setTimeout(() => {
            this.listKyc.find(c => c.id === item.id).Checked = e.target.ariaChecked === 'true' ? true : false;
        }, 100)
    }

    handleChangeClient(e, item) {
        setTimeout(() => {
            this.listClient.find(c => c.id === item.id).Checked = e.target.ariaChecked === 'true' ? true : false;
        }, 100)
    }

    parseValueFromUserInputRole(value: string) {
        for (let i = 0; i < this.listRole.length; i++) {
            if (this.listRole[i].text == value) return this.listRole[i].id
        }
        return ""
    }

    parseValueFromUserInputAccess(value: string) {
        for (let i = 0; i < this.listAccess.length; i++) {
            if (this.listAccess[i].text == value) return this.listAccess[i].id
        }
        return ""
    }

    get f() { return this.dataForm.controls; }
}


export function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    }
}
